<script>
    import MainContainer from '@/components/container/MainContainer.vue';

    import LeftPanel from '@/components/container/LeftPanel.vue';
    import RightContainer from '@/components/container/RightContainer.vue';

    import ButtonAnyNew from '@/components/left-panel/any-button/ButtonAnyNew.vue';
    import ButtonReturn from '@/components/left-panel/unique-buttons/ButtonReturn.vue';

    import ProviderAdd from '@/components/page-provider-and-game-edit/provider-add/ProviderAdd.vue';
    import ProviderEdit from '@/components/page-provider-and-game-edit/provider-edit/ProviderEdit.vue';
    import GameAdd from '@/components/page-provider-and-game-edit/game-add/GameAdd.vue';
    import GameEdit from '@/components/page-provider-and-game-edit/game-edit/GameEdit.vue';

    import ProviderList from '@/components/page-provider-and-game-edit/ProviderLIst.vue';

    import { calculatePromise, promiseAll } from '@/api/default.js';

    export default {
        components: {
            MainContainer: MainContainer,

            LeftPanel: LeftPanel,
            RightContainer: RightContainer,

            ButtonAnyNew: ButtonAnyNew,
            ButtonReturn: ButtonReturn,

            ProviderAdd: ProviderAdd,
            ProviderEdit: ProviderEdit,
            GameAdd: GameAdd,
            GameEdit: GameEdit,

            ProviderList: ProviderList,
        },
        async mounted() {
            this.$store.commit('IS_LOAD', true);
            const promiseList = await calculatePromise([
                {dispatch: 'CHECK_PROVIDER_AXIOS', commit: 'PROVIDERS', isArray: false},
                {dispatch: 'CHECK_GAMES_AXIOS', commit: 'GAMES', isArray: false},
                {dispatch: 'CHECK_PROVIDERS_AND_GAMES_AXIOS', commit: 'PROVIDERS_AND_GAMES', isArray: false},
            ]);
            await promiseAll(promiseList);
            this.$store.commit('IS_LOAD', false);
        },
        methods: {
            async toggleNewProvider() {
                this.$store.commit('IS_SHOW_PAG_PROVIDER_ADD',
                    this.$store.getters.IS_SHOW_PAG_PROVIDER_ADD === false
                );
                await this.$store.dispatch('CHECK_PROVIDER_ADD');
            },
            async toggleNewGame() {
                this.$store.commit('IS_SHOW_PAG_GAME_ADD',
                    this.$store.getters.IS_SHOW_PAG_GAME_ADD === false
                );
                await this.$store.dispatch('CHECK_GAME_ADD');
            },
        }
    }
</script>


<template>
    <ProviderAdd />
    <ProviderEdit />
    <GameAdd />
    <GameEdit />

    <MainContainer>
        <LeftPanel>
            <ButtonAnyNew
                title="New Provider"
                :method="toggleNewProvider"
            />
            <ButtonAnyNew
                title="New Game"
                :method="toggleNewGame"
            />
            <hr class="left-separator">
            <ButtonReturn />
        </LeftPanel>
        <RightContainer>
            <ProviderList />
        </RightContainer>
    </MainContainer>
</template>